import { useState } from 'react';
import { products } from '@/mocks/categories';

const featuredIds = ['prod-01', 'prod-04', 'prod-07', 'prod-09', 'prod-12', 'prod-03', 'prod-11', 'prod-08'];

export default function FeaturedProducts() {
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  const featuredProducts = products.filter((p) => featuredIds.includes(p.id));

  return (
    <section className="py-16 md:py-20 bg-background-100" aria-labelledby="featured-heading" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-50 text-accent-700 text-xs font-medium rounded-full mb-4">
            本周推荐
          </span>
          <h3 id="featured-heading" className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选时令好菜
          </h3>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            根据季节和产地，为您精选当下最新鲜、口感最佳的时令蔬菜
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredProducts.map((product, index) => (
            <div
              key={product.id}
              className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 cursor-pointer"
              style={{ animation: `slideUp 400ms ease-out ${index * 70}ms both` }}
              onMouseEnter={() => setHoveredId(product.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className="aspect-square overflow-hidden relative">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2 flex flex-col gap-1">
                  {product.isNew && (
                    <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                      新品
                    </span>
                  )}
                  {product.isHot && (
                    <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                      热卖
                    </span>
                  )}
                </div>
                {hoveredId === product.id && (
                  <div className="absolute inset-0 bg-black/10 flex items-center justify-center animate-[fadeIn_200ms_ease-out]">
                    <span className="px-4 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full">
                      查看详情
                    </span>
                  </div>
                )}
              </div>
              <div className="p-3 md:p-4">
                <h4 className="text-sm font-semibold text-foreground-900 mb-1">{product.name}</h4>
                <p className="text-xs text-foreground-400 mb-2">{product.subtitle}</p>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-base font-bold text-accent-600">¥{product.price}</span>
                    <span className="text-xs text-foreground-400 ml-1">/{product.unit}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{product.origin}</span>
                </div>
                {product.tags.length > 0 && (
                  <div className="flex flex-wrap gap-1 mt-2">
                    {product.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 bg-secondary-50 text-secondary-700 text-xs rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/categories"
            className="inline-flex items-center gap-2 px-6 py-3 border border-primary-300 text-primary-700 font-medium rounded-full text-sm hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部蔬菜
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}